module.exports = __webpack_public_path__ + "static/media/teamitem5.7a2cbe74.png";